export default __webpack_public_path__ + "static/media/Nav.1be5abb5.mp4";